export function ErrorPage() {
  return (
    <div data-testid="root-error-msg">
      <h1>We had trouble retrieving your code</h1>
      <p>Try reopening the link you were given.</p>
    </div>
  );
}
